import React, { FunctionComponent } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { IContextInfo } from '../../../rs-emd-ui-modules/src/models/master/context-info.model';
import { SSRContext } from '../../app/ssr-context';
import ProfileWrapper from '../profile-wrapper-component';
import ResetPasswordWrapper from '../reset-password-wrapper-component';
import MyAccountOrderDetailsWrapper from './my-account-order-details-wrapper-component';
import MyAccountOrdersWrapper from './my-account-orders-wrapper-component';
import MyAccountOverviewWrapper from './my-account-overview/my-account-overview-wrapper-component';
import MyAccountPartsListDetailsWrapper from './my-account-parts-list-details-wrapper-component';
import MyAccountPartsListsWrapper from './my-account-parts-lists-wrapper-component';

type RouterProps = {
  contextInfo: IContextInfo;
  isInLoggedInHomepage?: boolean;
};

export const MyAccountRouter: FunctionComponent<RouterProps> = (props: RouterProps) => {
  return (
    <Routes>
      <Route path='myaccount/resetPassword' element={<ResetPasswordWrapper />} />
      <Route path='profile' element={<ProfileWrapper contextInfo={props.contextInfo} />} />
      <Route path='myaccount/orders' element={<MyAccountOrdersWrapper />} />
      <Route path='myaccount/order/:orderId' element={<MyAccountOrderDetailsWrapper contextInfo={props.contextInfo} />} />
      <Route path='myaccount/partslists' element={<MyAccountPartsListsWrapper />} />
      <Route path='myaccount/partslist/:partslistId' element={<MyAccountPartsListDetailsWrapper contextInfo={props.contextInfo} />} />
      <Route path='myaccount' element={<MyAccountOverviewWrapper />} />
      <Route path='/' element={<MyAccountOverviewWrapper isInLoggedInHomepage={props.isInLoggedInHomepage} />} />

      <Route
        path='*'
        element={
          <SSRContext.Consumer>
            {(ctx) => {
              if (ctx) ctx.statusCode = 404;
              return <Navigate to='/error404/error404' replace />;
            }}
          </SSRContext.Consumer>
        }
      />
    </Routes>
  );
};
